module.exports = __webpack_public_path__ + "img/sort-button.466b0c7a.svg";